
// FOLLOWING CODES ARE MOCK SERVER IMPLEMENTATION

// YOU NEED TO BUILD YOUR OWN SERVER

// IF YOU NEED HELP ABOUT SERVER SIDE IMPLEMENTATION

// CONTACT US AT support@ui-lib.com

import * as db from "./data";
import navbarNavigation from "data/navbarNavigation";
import { categoryMenus } from "data/navigations";
export const LayoutEndpoints = Mock => {
  Mock.onGet("/api/layout").reply(() => {
    try {
      return [200, {
        footer: {
          appStoreUrl: "https://apps.apple.com/mx/app/d2g-beverage/id6468595202",
          playStoreUrl: "https://play.google.com/store/apps/details?id=com.consumer.d2g&hl=en&gl=US",
          logo: "/assets/images/d2glogo.png",
          contact: db.footerContact,
          about: db.footerAboutLinks,
          socials: db.footerSocialLinks,
          description: db.footerDescription,
          customers: db.footerCustomerCareLinks
        },
        mobileNavigation: {
          version1: db.mobileNavigation,
          version2: db.mobileNavigationTwo,
          logo: "/assets/images/d2glogo.png"
        },
        topbar: {
          label: "HOT",
          title: "Free Express Shipping",
          socials: db.topbarSocialLinks,
          languageOptions: db.languageOptions
        },
        header: {
          categories: db.categories,
          categoryMenus: categoryMenus,
          navigation: navbarNavigation,
          logo: "/assets/images/d2glogo.png"
        }
      }];
    } catch (err) {
      console.error(err);
      return [500, {
        message: "Internal server error"
      }];
    }
  });
};